import Vue from 'vue'
// import store from './store/store'
import Router from 'vue-router'
import Museum from '@/views/Museum.vue'
import Foundation from '@/views/Foundation.vue'
import Virtual from '@/views/Virtual.vue'
import Centrum from '@/views/CentrumEdukacji.vue'
import CentrumPage from '@/views/CentrumPage.vue'
import EventPage from '@/views/EventPage.vue'
import Product from '@/views/Product.vue'
import Search from '@/views/Search.vue'
import Contact from '@/views/Contact.vue'
import Menu from '@/views/Menu.vue'
import Statute from '@/views/Statute.vue'
import Regulations from '@/views/Regulations.vue'
import Privacy from '@/views/Privacy.vue'
import PageNotFound from '@/views/PageNotFound.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 80 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'menu',
      component: Menu
    },
    {
      path: '/muzeum',
      name: 'museum',
      component: Museum
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/rejestracja',
      name: 'register',
      component: Register
    },
    {
      path: '/fundacja',
      name: 'foundation',
      component: Foundation
    },
    {
      path: '/wydarzenia/:id',
      name: 'wydarzenia',
      component: EventPage
    },
    {
      path: '/centrum-edukacji',
      name: 'centrum-edukacji',
      component: Centrum
    },
    {
      path: '/centrum-edukacji/:page?',
      name: 'centrum-edukacji-page',
      component: CentrumPage
    },
    {
      path: '/wirtualne',
      name: 'virtual',
      component: Virtual
    },
    {
      path: '/wirtualne/eksponaty',
      name: 'search',
      component: Search
    },
    {
      path: '/wirtualne/brak-eksponatow',
      name: 'search-empty',
      component: Contact
    },
    {
      path: '/wirtualne/eksponat/:id',
      name: 'product',
      component: Product
    },
    {
      path: '/statut',
      name: 'statute',
      component: Statute
    },
    {
      path: '/regulamin',
      name: 'regulations',
      component: Regulations
    },
    {
      path: '/polityka-prywatnosci',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/kontakt',
      name: 'contact',
      component: Contact
    },
    {
      path: '/error404',
      name: 'notfound',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/error404'
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log('router.beforeEach to, from, next', to, from, next)
// })

export default router
